export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6411.63a2e179.jpg";